<div class="scrollbar" *ngIf="showScrollbar" #scrollbarDiv>
    <svg viewBox="0 0 375 60" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <svg:linearGradient x1="85.9375%" y1="10.7282366%" x2="15.7319568%" y2="91.2481399%" id="knob-gradient-scrollbar{{locationIdentifier}}">
                <svg:stop stop-color="#525252" offset="0%"></svg:stop>
                <svg:stop stop-color="#040404" offset="100%"></svg:stop>
            </svg:linearGradient>
            <svg:filter x="-31.0%" y="-19.0%" width="152.4%" height="152.4%" filterUnits="objectBoundingBox" id="knob-shadow-scrollbar{{locationIdentifier}}">
                <svg:feMorphology radius="2" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></svg:feMorphology>
                <svg:feOffset dx="-3" dy="4" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></svg:feOffset>
                <svg:feGaussianBlur stdDeviation="3.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></svg:feGaussianBlur>
                <svg:feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"></svg:feComposite>
                <svg:feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0" type="matrix" in="shadowBlurOuter1">
                </svg:feColorMatrix>
            </svg:filter>
            <svg:line x1="30" y1="30" x2="345" y2="30" id="scroll-bar{{locationIdentifier}}" />
        </defs>
        <svg:g id="bar-container">
            <svg:use class="bar-main" [attr.href]="'#scroll-bar'+locationIdentifier" #scrollbarLine></svg:use>
            <svg:use class="bar-white" y="1" [attr.href]="'#scroll-bar'+locationIdentifier"></svg:use>
        </svg:g>
        <svg:g>
            <svg:circle [attr.cx]="initialKnobCenter[0]" [attr.cy]="initialKnobCenter[1]" r="20" fill="black" fill-opacity="1" [attr.filter]="'url(#knob-shadow-scrollbar'+locationIdentifier+')'" #knobShadow/>
            <svg:circle class="knob" [attr.cx]="initialKnobCenter[0]" [attr.cy]="initialKnobCenter[1]" r="20" [attr.fill]="'url(#knob-gradient-scrollbar'+locationIdentifier+')'" #knob/>
            <svg:g>
                <svg:image x="20" y="25.5" width="20" height="9" preserveAspectRatio="xMidYMid meet" href="../../../assets/img/knob-arrows-slider.png" #knobArrow />
            </svg:g>
        </svg:g>
    </svg>
</div>